module.exports = __webpack_public_path__ + "img/partFor.03783341.png";